import { useCopilotAction } from '@copilotkit/react-core'

import { F0Alert } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

/**
 * Renders an AI credits warning alert when the current employee has exhausted
 * their personal AI credit cap. Has no call-to-action since employees cannot
 * self-serve more credits.
 */
export const useEmployeeCreditsWarningAction = () => {
  useCopilotAction({
    name: 'showEmployeeCreditsWarning',
    description:
      'Display a warning card when the current employee has no AI credits left for their personal cap.',
    parameters: [],
    available: 'frontend',
    render: () => (
      <F0Alert
        variant="warning"
        title={i18n.t('common.ai.credit_warning.employee_message_banner.title')}
        description={i18n.t('common.ai.credit_warning.employee_message_banner.description')}
      />
    ),
  })
}
